import React from "react";
import moment from "moment";

import { 
    Button, 
    Card, 
    Col, 
    Popconfirm, 
    Row, 
    message, 
    Table 
} from "antd";

import EnterpriseOciPunchoutCredentialsModal from "./enterprise-oci-punchout-credentials-modal";

import { 
    _getEnterpriseOciPunchoutCredentials,
    _deleteEnterpriseOciPunchoutCredentials
} from "../../services";

class EnterpriseOciPunchoutCredentials extends React.Component{

    constructor(props){
        super(props);

        if( !props.enterprise ){
            throw "EnterpriseOciPunchoutCredentials.props.enterprise is required!";
        }

        this.state = {

            enterpriseId: props.enterprise._id,

            /* keys */
            addCredentialsModalKey: "",

            /* boolean flags */
            loading: false,
            ociPunchoutCredentialsFetchAttempted: false,
            addCredentialsModalVisible: false,

            /* data */
            ociPunchoutCredentials: []
        };
    }

    async componentDidMount(){

        await this.getAndSetOciPunchoutCredentials();

    }

    render(){

        const { ociPunchoutCredentials } = this.state;
        return (
            <div>
                <Card title={this.renderTitle()}>
                    <Table 
                        columns={ this.renderColumns() }
                        loading={ this.getIsLoading() }
                        dataSource={ociPunchoutCredentials} />
                </Card>
                
                <EnterpriseOciPunchoutCredentialsModal 
                    enterprise={this.props.enterprise}
                    key={this.state.addCredentialsModalKey}
                    onCancel={ () => this.setModalState( false ) }
                    onAddNewCredentials={ this.onAddNewCredentials }
                    visible={this.state.addCredentialsModalVisible} />
            </div>
        );

    }

    renderTitle = () => {
        return (
            <Row justify="space-between" type="flex">
                <Col>
                    Oci Punchout Credentials
                </Col>
                <Col>
                    <Button 
                        onClick={ () => this.setModalState( true ) }
                        icon="plus" 
                        type="primary">Add</Button>
                </Col>
            </Row>
        )
        
    }

    renderColumns = () => {
        return [
            {
                title: "Username",
                key: "username",
                dataIndex: "username"
            },
            {
                title: "Department Code",
                key: "departmentCode",
                dataIndex: "departmentCode"
            },
            {
                title: "Country Code",
                key: "isoCountryCode",
                dataIndex: "isoCountryCode"
            },
            {
                title: "Date Created",
                key: "dateCreated",
                render: ( text, record ) => {
                    return (
                        moment(record.dateCreated).format("LLLL")
                    );
                }
            },
            {
                title: "Actions",
                key: "actions",
                render: ( text, record ) => {
                    return (
                        <Row>
                            <Col>
                                <Popconfirm 
                                    title="Are you sure? This cannot be reversed." 
                                    onConfirm={ () => this.onClickDeleteCredentials( record._id ) }>
                                    <Button type="danger">Delete</Button>
                                </Popconfirm>
                            </Col>
                        </Row>
                    )
                }
            }
        ]
    }

    getAndSetOciPunchoutCredentials = async () => {

        this.setState({
            loading: true
        });

        try{

            let res = await _getEnterpriseOciPunchoutCredentials( this.state.enterpriseId );

            if( !res.data.success ){
                throw "There was an unexpected error";
            }

            this.setState({
                loading: false,
                ociPunchoutCredentialsFetchAttempted: true,
                ociPunchoutCredentials: res.data.ociPunchoutCredentials
            })
    
        } catch( e ){

            this.setState({
                loading: false,
                ociPunchoutCredentialsFetchAttempted: true,
                ociPunchoutCredentials: []
            });

            message.error( e.toString() );
        }

    }

    getIsLoading = () => {

        if( !this.state.ociPunchoutCredentialsFetchAttempted ){
            return true;
        }

        if( this.state.loading ){
            return true;
        }

        return false;
    }

    onAddNewCredentials = ( _ociPunchoutCredentials ) => {

        this.setModalState( false );
        this.setState({
            ociPunchoutCredentials: [
                ...this.state.ociPunchoutCredentials,
                _ociPunchoutCredentials
            ]
        })

    }

    onClickDeleteCredentials = async ( ociPunchoutCredentialsId ) => {

        try{
            let res = await _deleteEnterpriseOciPunchoutCredentials( ociPunchoutCredentialsId );

            if( !res.data.success ){
                throw "There was an unexpected error";
            }

            message.success("Credentials Deleted Successfully!");
            
            await this.getAndSetOciPunchoutCredentials();
    
        } catch ( e ){
            message.error( e.toString() );
        }

    }

    setModalState = ( openClose = true ) => {

        let randomKey = `${Math.random() * 100000}`;

        this.setState({
            addCredentialsModalVisible: openClose,
            addCredentialsModalKey: randomKey
        });

    }


}

export default EnterpriseOciPunchoutCredentials;


// WEBPACK FOOTER //
// ./src/components/enterprise/enterprise-oci-punchout-credentials.js